import React, { useMemo } from 'react';
import { useStyles } from 'components/VideoPlayer/useStyles';
import { SkimProps } from 'components/VideoPlayer/type';
import clsx from 'clsx';

function Skim({ isShow, backgroundImage, timecode, skimPixelX, skimPercentY }: SkimProps) {
  const classes = useStyles();

  const skimLeft = useMemo(() => {
    return `${skimPixelX}px`;
  }, [skimPixelX]);

  const skimBackgroundPosition = useMemo(() => {
    return `0 -${skimPercentY * 67.5}px`;
  }, [skimPercentY]);

  return (
    <div className={clsx(classes.skimContainer, !isShow && classes.displayNone)}>
      <div
        className={classes.skim}
        style={{
          left: skimLeft,
          backgroundImage,
          backgroundPosition: skimBackgroundPosition,
        }}
      >
        <div className={classes.time}>
          <span>{timecode}</span>
        </div>
      </div>
    </div>
  );
}

export default Skim;
